import axios from "axios";
import { HOST } from "../../config";
export const ActionConst = {
  SET_DISPOSITIVOS: "CO_DISPOSITIVO_SET_DISPOSITIVOS",
  SET_FILTRO: "CO_DISPOSITIVO_SET_FILTRO",
  SET_SORT: "CO_DISPOSITIVO_SET_SORT",
  SET_CONTA: "CO_DISPOSITIVO_SET_CONTA",
  SET_DATASOURCE: "CO_DISPOSITIVO_SET_DATASOURCE",
  IS_FETCHING: "CO_DISPOSITIVO_IS_FETCHING",
  TOGGLE_DEVICE: "CO_DISPOSITIVO_TOGGLE_DEVICE",
  REMOVE: "CO_DISPOSITIVO_REMOVE",
  SET_DEVICE_KEYS: "SET_DEVICE_KEYS",
  CLEAN_DEVICE_KEYS: "CLEAN_DEVICE_KEYS",
};

function _setDispositivos(dispositivos) {
  return {
    type: ActionConst.SET_DISPOSITIVOS,
    dispositivos,
  };
}

function _setDataSource(dataSource) {
  return {
    type: ActionConst.SET_DATASOURCE,
    dataSource,
  };
}

function _setConta(conta) {
  return {
    type: ActionConst.SET_CONTA,
    conta,
  };
}

// args - {search, situacao}
export function setFiltro(args) {
  return {
    type: ActionConst.SET_FILTRO,
    args,
  };
}

function _setSort(sort) {
  return {
    type: ActionConst.SET_SORT,
    sort,
  };
}

function _isFetching(isFetching) {
  return {
    type: ActionConst.IS_FETCHING,
    isFetching,
  };
}

function _sort(sort, dataSource) {
  if (sort.property && sort.property !== "") {
    return dataSource.sort((a, b) => {
      let valueA = String(a[sort.property]).toLowerCase();
      let valueB = String(b[sort.property]).toLowerCase();

      if (sort.asc) {
        if (valueA < valueB) {
          return -1;
        } else if (valueA > valueB) {
          return 1;
        } else {
          return 0;
        }
      } else {
        if (valueA > valueB) {
          return -1;
        } else if (valueA < valueB) {
          return 1;
        } else {
          return 0;
        }
      }
    });
  }
}

function _aplicarFiltro(args) {
  let { filter_property, expressao, dispositivos, sort } = args;
  let dataSource = [];

  if (dispositivos && dispositivos.length > 0) {
    if (expressao && expressao !== "") {
      expressao = String(expressao).toUpperCase();

      dataSource = dispositivos.filter((item) => {
        return filter_property.find((property) => {
          let value = String(item[property]).toUpperCase();
          return value.indexOf(expressao) > -1;
        });
      });
    } else {
      dataSource = [...dispositivos];
    }
  }
  return _sort(sort, dataSource);
}

export function buscar() {
  return (dispatch, getState) => {
    let { filter_property, expressao, dispositivos, sort } =
      getState().coDispositivo;

    dispatch(_isFetching(true));
    setTimeout(() => {
      let dataSource = _aplicarFiltro({
        filter_property,
        expressao,
        dispositivos,
        sort,
      });
      dispatch(_setDataSource(dataSource));
      dispatch(_isFetching(false));
    });
  };
}

function _KeysDevice(keys) {
  return {
    type: ActionConst.SET_DEVICE_KEYS,
    keys,
  };
}

function _cleanKeys() {
  return {
    type: ActionConst.CLEAN_DEVICE_KEYS,
  };
}
export function cleanDeviceKey() {
  return (dispatch, getState) => {
    dispatch(_cleanKeys());
  };
}

export function getKeysDevice(deviceKey, callback) {
  return (dispatch, getState) => {
    dispatch(_isFetching(true));

    let url = `${HOST}/api/mobile/accounts/${deviceKey.account}/devices/${deviceKey.id}/keys`;
    axios
      .get(url)
      .then((res) => {
        let keys = res.data;
        dispatch(_KeysDevice(keys), callback());
        dispatch(_isFetching(false));
      })
      .catch((err) => {
        dispatch(_isFetching(false));
      });
  };
}

export function qsort(property) {
  return (dispatch, getState) => {
    let { sort } = getState().coDispositivo;
    let asc = true;
    if (sort.property === property) {
      asc = !sort.asc;
    }
    dispatch(_setSort({ property, asc }));
    dispatch(buscar());
  };
}

function _getDispositivos() {
  //10.95.3.30:57772/api/mobile/devices/accounts/I432
  return (dispatch, getState) => {
    let { conta } = getState().coDispositivo;

    let url = `${HOST}/api/mobile/accounts/${conta}/devices`;

    return axios
      .get(url)
      .then((response) => {
        let { devices } = response.data;
        dispatch(_setDispositivos(devices));
      })
      .catch((error) => {
        if (error.response) {
          error = error.response.data.error;
        }
        return Promise.reject(error);
      });
  };
}

function _toggleDevice(id) {
  return {
    type: ActionConst.TOGGLE_DEVICE,
    id,
  };
}

export function toggleDevice(id) {
  //10.95.3.30:57772/api/mobile/devices/accounts/I432
  return (dispatch, getState) => {
    let { conta } = getState().coDispositivo;

    let url = `${HOST}/api/mobile/accounts/${conta}/devices/${id}`;

    dispatch(_isFetching(true));
    return axios
      .put(url)
      .then((response) => {
        dispatch(_isFetching(false));
        dispatch(_toggleDevice(id));
        return response;
      })
      .catch((error) => {
        dispatch(_isFetching(false));
        if (error.response) {
          error = error.response.data.error;
        }
        return Promise.reject(error);
      });
  };
}

function _remove(id) {
  return {
    type: ActionConst.REMOVE,
    id,
  };
}

export function remove(id) {
  return (dispatch, getState) => {
    let { conta } = getState().coDispositivo;

    let url = `${HOST}/api/mobile/accounts/${conta}/devices/${id}`;

    dispatch(_isFetching(true));
    return axios
      .delete(url)
      .then((response) => {
        dispatch(_isFetching(false));
        dispatch(_remove(id));
        return response;
      })
      .catch((error) => {
        dispatch(_isFetching(false));
        if (error.response) {
          error = error.response.data.error;
        }
        return Promise.reject(error);
      });
  };
}

export function load(conta) {
  return (dispatch) => {
    //Novo usuario
    dispatch(_isFetching(true));
    if (conta) {
      dispatch(_setConta(conta));
    }

    return Promise.all([dispatch(_getDispositivos())])
      .then(() => {
        dispatch(buscar());
      })
      .catch((error) => {
        dispatch(_isFetching(false));
        return Promise.reject(error);
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/dispositivo/CoDispositivo.js